import { useEffect, useRef } from "react";

import { Column } from "@/components";
import { Progress } from "@/components/ui/progress";

import { fireFullPageConfetti } from "@/lib/confetti";

export const IntakeProgress = ({
  filled,
  isDataSettled,
  onComplete,
  total,
}: {
  filled: number;
  isDataSettled: boolean;
  onComplete?: () => void;
  total: number;
}) => {
  const percentage = total > 0 ? Math.round((filled / total) * 100) : 0;
  const isComplete = total > 0 && filled >= total;
  const hasSettledRef = useRef(false);
  const prevCompleteRef = useRef(false);

  useEffect(() => {
    if (!isDataSettled) return;

    if (!hasSettledRef.current) {
      hasSettledRef.current = true;
      prevCompleteRef.current = isComplete;
      return;
    }
    if (isComplete && !prevCompleteRef.current) {
      fireFullPageConfetti();
      onComplete?.();
    }
    prevCompleteRef.current = isComplete;
  }, [isComplete, isDataSettled, onComplete]);

  return (
    <Column className="gap-2 border-t border-slate-200 pt-4">
      <Progress value={percentage} />
      <p className="text-xs text-slate-500">{percentage}% complete</p>
    </Column>
  );
};
